<template>
    <div>
        <Title :title="'排课管理'" :noBorder="true"></Title>
        <Menu mode="horizontal" :theme="'light'" active-name="classManage" class="tabs" @on-select="menuChange">
            <MenuItem name="classManage">
                排课管理
            </MenuItem>
            <MenuItem name="schoolYear">
                学年管理
            </MenuItem>
        </Menu>
        <div>
<!--            <keep-alive>-->
                <component :is="currentPage"></component>
<!--            </keep-alive>-->
        </div>
    </div>
</template>

<script>
    import Title from "../../ability/components/title";
    import classManage from "./rangemanage/classManage";
    import schoolYear from "./rangemanage/schoolYear";
    export default {
        name: "rangemanage",
        components: {
            Title,
            classManage,
            schoolYear
        },
        data() {
            return {
                currentPage:'classManage'
            }
        },
        methods: {
            menuChange(name){
                this.currentPage = name
            }
        }
    }
</script>
<style lang="less">
    .table-box {
        label {
            margin-bottom: 0;
        }
    }
</style>
<style scoped lang="less">
    @import "../style/index";

</style>
